export function cleanUrlDisplay(url: string) {
  if (!url) {
    return "";
  }

  url = url.replace(/^https?:\/\//, "");
  // Replace "www."
  url = url.replace(/^www\./, "");

  return url;
}
